var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// api/zusammenhangskomponente.ts
import { logger } from "@adornis/base/logging.js";
import { Entity, Field } from "@adornis/baseql/decorators.js";
import { DataLoadedField } from "@adornis/baseql/decorators/data-loaded-field.js";
import { MongoEntity } from "@adornis/baseql/entities/mongoEntity.js";
import { Beleg } from "./beleg.js";
import { Buchung } from "./buchung.js";
var Zusammenhangskomponente = class extends MongoEntity {
  constructor(doc) {
    super(doc);
  }
  static async beforeCreate(entity) {
    if ((entity.buchungsIDs?.length ?? 0) + (entity.belegIDs?.length ?? 0) <= 1) {
      logger.error({ entity: entity.toObject() }, "cant create Zusammenhangskomponente with only one Beleg or Buchung");
      throw new Error("cant create Zusammenhangskomponente with only one Beleg or Buchung");
    }
    if (new Set(entity.buchungsIDs).size !== entity.buchungsIDs?.length) {
      logger.error({ entity: entity.toObject() }, "trying to connect one buchungsID to itself");
      throw new Error("trying to connect one buchungsID to itself");
    }
  }
};
Zusammenhangskomponente._class = "Zusammenhangskomponente";
Zusammenhangskomponente._collectionName = "zusammenhangskomponenten";
__decorateClass([
  Field((type) => String)
], Zusammenhangskomponente.prototype, "comment", 2);
__decorateClass([
  Field((type) => [String], { default: (v) => v ?? [] })
], Zusammenhangskomponente.prototype, "buchungsIDs", 2);
__decorateClass([
  DataLoadedField((type) => [Buchung], ({ buchungsIDs }) => buchungsIDs ?? [])
], Zusammenhangskomponente.prototype, "buchungen", 2);
__decorateClass([
  Field((type) => [String], { default: (v) => v ?? [] })
], Zusammenhangskomponente.prototype, "belegIDs", 2);
__decorateClass([
  DataLoadedField((type) => [Beleg], ({ belegIDs }) => belegIDs ?? [])
], Zusammenhangskomponente.prototype, "belege", 2);
Zusammenhangskomponente = __decorateClass([
  Entity()
], Zusammenhangskomponente);
export {
  Zusammenhangskomponente
};
